import es6Promise from 'es6-promise'

es6Promise.polyfill()



// WEBPACK FOOTER //
// ./src/utilities/pollyfills/index.js